/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetCompaniesNearMePreSearchResponse } from '../../models/get-companies-near-me-pre-search-response';
import { GetCompaniesNearMeRequest } from '../../models/get-companies-near-me-request';

export interface GetCompaniesNearMePreSearch$Params {
      body: GetCompaniesNearMeRequest
}

export function getCompaniesNearMePreSearch(http: HttpClient, rootUrl: string, params: GetCompaniesNearMePreSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCompaniesNearMePreSearchResponse>> {
  const rb = new RequestBuilder(rootUrl, getCompaniesNearMePreSearch.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetCompaniesNearMePreSearchResponse>;
    })
  );
}

getCompaniesNearMePreSearch.PATH = '/api/companies-near-me-pre-search';
